import { useNavigate } from 'react-router-dom';

export default function EventosCorporativosPage() {
  const navigate = useNavigate();

  const eventTypes = [
    {
      id: 1,
      title: 'Aniversários Corporativos',
      description: 'Celebre os marcos importantes da sua empresa com nossos produtos especiais para eventos corporativos.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20anniversary%20celebration%20with%20employees%20celebrating%20company%20milestone%2C%20modern%20office%20party%20setting%2C%20elegant%20catering%20setup%2C%20team%20gathering%20with%20decorations%2C%20business%20celebration%20event%2C%20warm%20lighting&width=600&height=400&seq=aniversario-corporativo-1&orientation=landscape',
      features: ['Buffet completo', 'Decoração personalizada', 'Cardápio sob medida', 'Equipe especializada']
    },
    {
      id: 2,
      title: 'Confraternizações',
      description: 'Torne suas confraternizações inesquecíveis com nosso serviço completo de alimentação.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20celebration%20party%20with%20colleagues%20enjoying%20food%20and%20drinks%2C%20modern%20office%20environment%2C%20professional%20catering%20service%2C%20happy%20employees%20socializing%2C%20festive%20atmosphere%2C%20warm%20ambient%20lighting&width=600&height=400&seq=confraternizacao-1&orientation=landscape',
      features: ['Variedade de pratos', 'Bebidas inclusas', 'Serviço de garçons', 'Montagem e desmontagem']
    },
    {
      id: 3,
      title: 'Eventos de Integração',
      description: 'Fortaleça o espírito de equipe com eventos de integração e alimentação de qualidade.',
      image: 'https://readdy.ai/api/search-image?query=Corporate%20team%20building%20event%20with%20employees%20participating%20in%20group%20activities%2C%20outdoor%20company%20gathering%2C%20professional%20catering%20setup%2C%20collaborative%20atmosphere%2C%20modern%20business%20setting%2C%20natural%20daylight&width=600&height=400&seq=integracao-1&orientation=landscape',
      features: ['Cardápio flexível', 'Opções vegetarianas', 'Serviço personalizado', 'Suporte completo']
    },
    {
      id: 4,
      title: 'Reuniões e Workshops',
      description: 'Coffee breaks e refeições para reuniões e workshops corporativos.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20corporate%20meeting%20with%20coffee%20break%20setup%2C%20business%20workshop%20catering%20service%2C%20modern%20conference%20room%2C%20elegant%20food%20presentation%2C%20professional%20environment%2C%20bright%20natural%20lighting&width=600&height=400&seq=reuniao-workshop-1&orientation=landscape',
      features: ['Coffee break', 'Lanches rápidos', 'Refeições executivas', 'Entrega pontual']
    }
  ];

  const packages = [
    {
      name: 'Pacote Básico',
      price: 'A partir de R$ 45/pessoa',
      items: [
        'Salgados variados (5 unidades)',
        'Refrigerantes e sucos',
        'Sobremesa simples',
        'Descartáveis inclusos'
      ]
    },
    {
      name: 'Pacote Executivo',
      price: 'A partir de R$ 75/pessoa',
      items: [
        'Buffet completo (entrada, prato principal, acompanhamentos)',
        'Bebidas variadas',
        'Sobremesas premium',
        'Louças e talheres',
        'Equipe de garçons'
      ],
      featured: true
    },
    {
      name: 'Pacote Premium',
      price: 'A partir de R$ 120/pessoa',
      items: [
        'Menu personalizado',
        'Estações de comida',
        'Bar completo',
        'Decoração temática',
        'Equipe completa',
        'Coordenação do evento'
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20corporate%20event%20celebration%20with%20professional%20catering%20setup%2C%20modern%20business%20party%20atmosphere%2C%20sophisticated%20food%20presentation%2C%20company%20celebration%20with%20employees%2C%20upscale%20venue%20setting%2C%20warm%20elegant%20lighting%2C%20festive%20corporate%20environment&width=1920&height=1080&seq=hero-eventos-corporativos&orientation=landscape"
            alt="Eventos Corporativos"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Eventos Corporativos</h1>
          <p className="text-xl md:text-2xl mb-8 font-light">
            Transforme seus eventos empresariais em experiências memoráveis com nosso serviço completo de alimentação
          </p>
          <button
            onClick={() => {
              const form = document.getElementById('contact-form');
              if (form) {
                form.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            Solicitar Orçamento
          </button>
        </div>
      </section>

      {/* Tipos de Eventos */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Tipos de Eventos</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Oferecemos soluções completas para diversos tipos de eventos corporativos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {eventTypes.map((event) => (
              <div
                key={event.id}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow"
              >
                <div className="h-64 w-full overflow-hidden">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{event.title}</h3>
                  <p className="text-gray-600 mb-4">{event.description}</p>
                  <ul className="space-y-2">
                    {event.features.map((feature, index) => (
                      <li key={index} className="flex items-center text-gray-700">
                        <i className="ri-check-line text-orange-500 mr-2 text-xl"></i>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pacotes */}
      <section className="py-20 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Nossos Pacotes</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Escolha o pacote ideal para o seu evento corporativo
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <div
                key={index}
                className={`bg-white rounded-xl p-8 ${
                  pkg.featured
                    ? 'ring-2 ring-orange-500 shadow-xl transform scale-105'
                    : 'shadow-lg'
                }`}
              >
                {pkg.featured && (
                  <div className="bg-orange-500 text-white text-sm font-bold px-4 py-1 rounded-full inline-block mb-4 whitespace-nowrap">
                    Mais Popular
                  </div>
                )}
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                <p className="text-3xl font-bold text-orange-500 mb-6">{pkg.price}</p>
                <ul className="space-y-3 mb-8">
                  {pkg.items.map((item, idx) => (
                    <li key={idx} className="flex items-start text-gray-700">
                      <i className="ri-check-line text-orange-500 mr-2 text-xl flex-shrink-0 mt-0.5"></i>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => {
                    const form = document.getElementById('contact-form');
                    if (form) {
                      form.scrollIntoView({ behavior: 'smooth' });
                    }
                  }}
                  className={`w-full py-3 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    pkg.featured
                      ? 'bg-orange-500 hover:bg-orange-600 text-white'
                      : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                  }`}
                >
                  Solicitar Orçamento
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Diferenciais */}
      <section className="py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Por Que Escolher a Sustentare?</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Experiência e qualidade em cada detalhe do seu evento
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-award-line',
                title: 'Experiência',
                description: 'Mais de 20 anos atendendo eventos corporativos'
              },
              {
                icon: 'ri-restaurant-line',
                title: 'Qualidade',
                description: 'Ingredientes selecionados e preparação profissional'
              },
              {
                icon: 'ri-team-line',
                title: 'Equipe Especializada',
                description: 'Profissionais treinados e dedicados'
              },
              {
                icon: 'ri-customer-service-line',
                title: 'Atendimento',
                description: 'Suporte completo do planejamento à execução'
              }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${item.icon} text-4xl text-orange-500`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Formulário de Contato */}
      <section id="contact-form" className="py-20 px-4 bg-gray-50">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Solicite um Orçamento</h2>
            <p className="text-lg text-gray-600">
              Preencha o formulário e entraremos em contato em até 24 horas
            </p>
          </div>

          <form
            data-readdy-form
            id="eventos-corporativos-form"
            className="bg-white rounded-xl shadow-lg p-8"
            onSubmit={async (e) => {
              e.preventDefault();
              const form = e.currentTarget;
              const formData = new FormData(form);
              const submitButton = form.querySelector('button[type="submit"]') as HTMLButtonElement;
              const originalText = submitButton.textContent;

              try {
                submitButton.disabled = true;
                submitButton.textContent = 'Enviando...';

                const response = await fetch('https://readdy.ai/api/form/d5ilrvjihlvellpk5ed0', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                  },
                  body: new URLSearchParams(formData as any).toString(),
                });

                if (response.ok) {
                  alert('Orçamento solicitado com sucesso! Entraremos em contato em breve.');
                  form.reset();
                } else {
                  alert('Erro ao enviar. Por favor, tente novamente.');
                }
              } catch (error) {
                alert('Erro ao enviar. Por favor, tente novamente.');
              } finally {
                submitButton.disabled = false;
                submitButton.textContent = originalText;
              }
            }}
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="nome" className="block text-sm font-medium text-gray-700 mb-2">
                  Nome Completo *
                </label>
                <input
                  type="text"
                  id="nome"
                  name="nome"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                  E-mail *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="telefone" className="block text-sm font-medium text-gray-700 mb-2">
                  Telefone *
                </label>
                <input
                  type="tel"
                  id="telefone"
                  name="telefone"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                />
              </div>
              <div>
                <label htmlFor="empresa" className="block text-sm font-medium text-gray-700 mb-2">
                  Empresa *
                </label>
                <input
                  type="text"
                  id="empresa"
                  name="empresa"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
              <div>
                <label htmlFor="tipo-evento" className="block text-sm font-medium text-gray-700 mb-2">
                  Tipo de Evento *
                </label>
                <select
                  id="tipo-evento"
                  name="tipo-evento"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm cursor-pointer"
                >
                  <option value="">Selecione</option>
                  <option value="aniversario">Aniversário Corporativo</option>
                  <option value="confraternizacao">Confraternização</option>
                  <option value="integracao">Evento de Integração</option>
                  <option value="reuniao">Reunião/Workshop</option>
                  <option value="outro">Outro</option>
                </select>
              </div>
              <div>
                <label htmlFor="numero-pessoas" className="block text-sm font-medium text-gray-700 mb-2">
                  Número de Pessoas *
                </label>
                <input
                  type="number"
                  id="numero-pessoas"
                  name="numero-pessoas"
                  required
                  min="1"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm"
                />
              </div>
            </div>

            <div className="mb-6">
              <label htmlFor="data-evento" className="block text-sm font-medium text-gray-700 mb-2">
                Data do Evento *
              </label>
              <input
                type="date"
                id="data-evento"
                name="data-evento"
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm cursor-pointer"
              />
            </div>

            <div className="mb-6">
              <label htmlFor="mensagem" className="block text-sm font-medium text-gray-700 mb-2">
                Mensagem / Detalhes do Evento
              </label>
              <textarea
                id="mensagem"
                name="mensagem"
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-transparent text-sm resize-none"
                placeholder="Conte-nos mais sobre o seu evento..."
              ></textarea>
              <p className="text-xs text-gray-500 mt-1">Máximo 500 caracteres</p>
            </div>

            <button
              type="submit"
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-4 rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              Enviar Solicitação
            </button>
          </form>
        </div>
      </section>
    </div>
  );
}
